module.exports = __webpack_public_path__ + "img/zjcl.1e654b18.jpg";